<template>
  <div>
    <el-collapse v-model="activeNames">
      <el-collapse-item
        @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '1')"
        title="手风琴设置"
        name="1"
      >
        <slider-and-input
          inputWidth="small"
          :value.sync="activePercent"
          title="展开页占比"
          :sliderMax="100"
          :sliderMin="1"
          suffix="%"
        />
        <div class="verticallyCenter mt12">
          <span class="mr16">切换方式</span>
          <div class="font-arrangement-btn height32 flex1">
            <span class="btn-active" :style="getTranslate"></span>
            <span
              v-for="(val, index) in changeWayList"
              :key="index"
              :class="changeWayType == val.label ? 'select' : ''"
              @click="changeWays(val.label)"
              >{{ val.title }}</span
            >
          </div>
        </div>
        <div class="verticallyCenter mt12">
          <span class="fs14 mr20">默认展开第</span>
          <el-input
            class="cx_style width76"
            v-model="openIndex"
            placeholder="请输入"
            v-inputHandle="{ this1, type: 'openIndex',env: request_prefix, max: inputMax, min: 1}"
            type="number"
            @focus="getFocus($event)"
          >
            <template slot="suffix">
              <span class="suffix_text"></span>
            </template>
          </el-input>
          <span class="ml8">页</span>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import { CATEGORY_MODE } from "@/consts"
export default {
  components: {},
  props: {},
  data() {
    return {
      this1: this,
      activeNames: ["1", "2", "3"],
      collapseActiveNames: ["1", "2", "3"],
      changeWayList: [
        {
          label: 0,
          title: "点击"
        },
        {
          label: 1,
          title: "悬浮"
        }
      ],
      translate: 0,
    }
  },
  watch: {
    inputMax(newVal, oldVal) {
      if (newVal < oldVal && this.openIndex === oldVal) {
        this.openIndex = newVal
      }
    },
  },
  mounted() {
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    getOptions: function () {
      return this.$getOptions(this.ids)
    },
    openIndex: {
      get() {
        const useActiveIndex = this.getOptions.categoryMode === CATEGORY_MODE.SAME ? 0 : this.getOptions.activeIndex
        return this.getOptions.rows[useActiveIndex].openIndex + 1
      },
      set(newVal) {
        // 控制输入框可输入的最大最小值
        if (newVal < 1 || newVal > this.inputMax) {
          return
        }
        let width = this.activeCol && parseInt(this.activeCol.width)
        if (this.verticalAccordion && this.activeCol) {
          width = parseInt(this.activeCol.height)
        }
        this.getOptions.rows.forEach(rowsItem => {
          this.$store.dispatch(this.request_prefix + "/changeRowColSize", {
            ...this.ids,
            type: "openIndex",
            row: rowsItem,
            val: newVal - 1
          })
        })
        if (width !== undefined) this.activePercent = width
      }
    },
    inputMax() {
      const useActiveIndex = this.getOptions.categoryMode === CATEGORY_MODE.SAME ? 0 : this.getOptions.activeIndex
      let layoutType = this.getOptions.rows[useActiveIndex].cols[0].componentBoxOptions.layoutType
      let rows = this.getOptions.rows[useActiveIndex].cols[0].rows
      let cols = rows[0].cols
      if (this.verticalAccordion) {        
        if (!layoutType) {
          return rows.length
        } else {
          return rows[0].cols[0].rows.length
        }
      } else {
        if (!layoutType) {
          return cols.length
        } else {
          return cols[0].rows[0].cols.length
        }
      } 
    },
    activeCol() {
      const useActiveIndex = this.getOptions.categoryMode === CATEGORY_MODE.SAME ? 0 : this.getOptions.activeIndex
      let layoutType = this.getOptions.rows[useActiveIndex].cols[0].componentBoxOptions.layoutType
      if (this.verticalAccordion) {
        let rows = this.getOptions.rows[useActiveIndex].cols[0].rows        
        if (!layoutType) {
          return rows[this.openIndex - 1]
        } else {        
          return rows[0].cols[0].rows[this.openIndex - 1]
        }
      } else {
        let cols = this.getOptions.rows[useActiveIndex].cols[0].rows[0].cols
        if (!layoutType) {
          return cols[this.openIndex - 1]
        } else {        
          return cols[0].rows[0].cols[this.openIndex - 1]
        }
      }
    },
    activePercent: {
      get() {
        let width = this.activeCol?.width
        let height = this.activeCol?.height
        if (this.verticalAccordion) {          
          return parseInt(height)
        } else {
          return parseInt(width)
        }
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activePercent", false)
        this.setWidth(newVal)
      }
    },
    getTranslate() {
      return {
        transform: `translateX(${this.translate}px)`
      }
    },
    changeWayType: {
      get() {
        let index = this.changeWayList.findIndex(item => item.label === this.getOptions.changeWayType)
        this.translate = 75.5 * index < 0 ? 0 : 75.5 * index
        return this.getOptions.hasOwnProperty("changeWayType") ? this.getOptions.changeWayType : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "changeWayType", false)
      }
    },
    verticalAccordion() {
      if (this.getOptions.accordionType && this.getOptions.accordionType === "vertical") return true
      return false
    },
  },
  methods: {
    changeWays(val) {
      this.changeWayType = val
    },
    getFocus(event) {
      event.currentTarget.select()
    },
    setWidth(newWidth) {
      this.getOptions.rows.forEach(rowsItem => {
        const useActiveIndex = this.getOptions.categoryMode === CATEGORY_MODE.SAME ? 0 : this.getOptions.activeIndex
        let layoutType = this.getOptions.rows[useActiveIndex].cols[0].componentBoxOptions.layoutType
        let colsLen = this.inputMax
        let otherWidth = (100 - newWidth) / (colsLen - 1)
        let rows = rowsItem.cols[0].rows
        let cols = rows[0].cols
        let colsList = this.verticalAccordion ? rows : cols
        if (layoutType) {
          if (this.verticalAccordion) {
            colsList = rows[0].cols[0].rows
          } else {
            colsList = cols[0].rows[0].cols
          }
        }
        colsList.forEach((colsItem, colsIndex) => {
          let newType = "width"
          if (this.verticalAccordion) {
            newType = "colHeight"
          }
          if (colsIndex === this.openIndex - 1) {
            this.$store.dispatch(this.request_prefix + "/changeRowColSize", {
              ...this.ids,
              type: newType,
              col: colsItem,
              val: newWidth + "%"
            })
          } else {
            this.$store.dispatch(this.request_prefix + "/changeRowColSize", {
              ...this.ids,
              type: newType,
              col: colsItem,
              val: otherWidth + "%"
            })
          }
        })
      })
    },
  }
}
</script>

<style lang="scss">
.font-arrangement-btn {
  height: 32px;
}
.font-arrangement-btn .btn-active {
  width: calc((100% - 6px) / 2);
}
.font-arrangement-btn.height32 span {
  font-size: 18px;
  height: 26px;
  font-size: 13px;
  line-height: 26px;
}
.width76 {
  width: 76px;
}
</style>